/*
 * Copyright (C) 2018 Bruno López Trigo
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React, { Component, Fragment } from "react";
import NavBar from "../components/global/NavBar";
import { Grid } from "@material-ui/core";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Redirect } from "react-router-dom";
import CustomizedSnackbars from "../components/global/CustomizedSnackbars";
import galicia from "../components/images/galicia.png";
import citius_horizontal from "../components/images/citius_horizontal.png";
import xacobeo from "../components/images/xacobeo-color-original.jpg";
import usc from "../components/images/usc.png";
import campusVida from "../components/images/campusvida.png";
import ue from "../components/images/ue.png";
import xunta from "../components/images/xunta.png";
import DoubleHomeCard from "../components/home/DoubleHomeCard";
import Typography from "@material-ui/core/Typography";
import CardContent from "@material-ui/core/CardContent";

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  footer:{
    boxShadow: "0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
      display:"block",
    justifyContent:"space-evenly",
      position:"fixed",
      bottom:0,
      height:"auto",
      left:0,
      width:"100%",
      backgroundColor:"white",
},
    centerFotter:{
        display:"flex",
        justifyContent:"space-evenly",
    },
    leftLogos: {
        height: 36,
        marginTop: 20,
        marginBottom: 20
    },
    rightLogos: {
        height: 60,
        marginTop: 20,
        marginBottom: 20
    },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary
  },
  appBar: {
    position:"relative",
    top: 0,
    left:0,
    bottom: 0,
    width:"100%",
    zIndex: -1,
    backgroundColor: "white"
  },
  toolbar: {
    alignItems: "center",
    justifyContent: "space-around"
  }
});

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false
    };
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    this.setState({
      error: false
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <Fragment>
        <NavBar
          language={this.props.language}
          handleLanguageChange={this.props.handleLanguageChange}
        />
        <Grid style={{marginBottom:200}} container justify="center">
            <DoubleHomeCard
              language={this.props.language}
              startSession={this.props.startSession}
              startSessionBeginner={this.props.startSessionBeginner}
            />
          </Grid>
        <footer className={classes.footer}>
            <Grid container direction="row" alignItems="center" justify={"center"}>
                <Grid  className={classes.centerFotter} item xs={12} md={8} lg={8} >
                    <img
                      src={galicia}
                      alt="logo turístico galicia"
                      className={classes.leftLogos}
                    />
                    <img
                        src={xacobeo}
                        alt="logo xacobeo 2021"
                        className={classes.leftLogos}
                    />
                    <img src={citius_horizontal} alt="logo citius" className={classes.leftLogos} />
                    <img src={usc} alt="logo usc" className={classes.leftLogos} />
                    <img
                        src={campusVida}
                        alt="logo campus vida"
                        className={classes.leftLogos}
                    />
                </Grid>
                <Grid className={classes.centerFotter}  item xs={12} md={4} lg={4} >
                    <img
                      src={ue}
                      alt="logo unión europea"
                      className={classes.rightLogos}
                    />
                    <img
                      src={xunta}
                      alt="logo xunta de galicia"
                      className={classes.rightLogos}
                    />
                </Grid>
            </Grid>
            <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "center"}}>
                {this.props.language.labels[this.props.language.id].fondoEuropeo}
            </Typography>
          </footer>
        <CustomizedSnackbars
          openFail={this.state.error}
          handleClose={this.handleClose}
          message={this.state.message}
        />
        {this.props.token ? this.props.goToDataset && <Redirect to="/datasets" /> : ""}
      </Fragment>
    );
  }
}

Home.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Home);
